// 公共接口 文件
import request from "@/utils/request";
// 获取楼宇 位置
export function floor() {
  return request({
    url: "/base/dict/data/v1/building/list",
    method: "get",
  });
}
// 根据楼宇 获取楼层
export function leve(data) {
  return request({
    url: `/base/dict/data/v1/building/floor/list?buildingId=${data}`,
    method: "get",
  });
}
// 根据楼层 获取教室
export function roomlist(data) {
  return request({
    url: `/base/dict/data/v1/classroom/list?buildingFloorId=${data}`,
    method: "get",
  });
}

// 用户管理-删除(身份)(t) 用于:教师管理/学生管理/管理员管理/家长管理/游客管理删除按钮)
export function DeleteUser(data) {
  return request({
    url: "/base/user/v1/identity/delete",
    method: "post",
    data: data,
  });
}
// 字典数据-角色列表
export function rolelist(data) {
  return request({
    url: `/base/dict/data/v1/role/list?identityId=${data}`,
    method: "get",
  });
}

// 字典数据 院系列表
export function gradelist() {
  return request({
    url: `/base/dict/data/v1/getDeptUsers?queryName=${''}`,
    method: "get",
  });
}
// 字典数据 班级列表 根据院系获取
export function classList(data) {
  return request({
    url: `/base/dict/data/v1/class/list?gradeId=${data}`,
    method: "get",
  });
}

// 字典数据 班级列表 根据院系获取
export function classList_copy() {
  return request({
    url: `/base/dict/data/v1/class/list`,
    method: "get",
  });
}

// 字典数据 课程列表
export function subjectList() {
  return request({
    url: `/base/course/v1/list`,
    method: "post",
    data:{
      pageNum: -1,
      pageSize: -1
    }
  });
}
// 获取当前用户身份列表里面是否包含 自定义角
export function getUserRoleList(data) {
  return request({
    url: `/app/zhkt/role/v1/getUserRoleTrue?userId=${data}`,
    method: "get",
  });
}

// 验证当前六地址是否有流
export function isVidedoUrl(data) {
  return request({
    url: `/base/device/v1/getStreamInFo`,
    method: "get",
    params: data,
  });
}
// 获取公网直播 分辨率 码率列表
export function getPublicM3u8() {
    return request({
      url: `/base/base/public/live/arg/v1/get/list`,
      method: "get"
    });
}
  
